<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <AccessRightModal :ref="modalKey" @on-item-saved="onItemSaved" />
  </div>
</template>

<script>
import AccessRightService from "@/services/AccessRightService";
import AccessRightModal from "@/components/administration/accessRight/AccessRightModal.vue";
import Utils from "@/ecm/common/Utils";

export default {
  components: {
    AccessRightModal,
  },

  data() {
    return {
      title: this.$t("AccessRights"),
      grid: {
        key: "accessRightGrid",
        dataSource: AccessRightService.getGrid(),
        columns: [
          {
            field: "Name",
            caption: this.$t("Name"),
            type: "string",
          },
        ],
      },
      modalKey: "modalAccessRight",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    editItem(dto) {
      this.modalInstance.edit(dto);
    },
    deleteItem(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          AccessRightService.delete(dto.Id).then((result) => {
            this.gridInstance.refresh();
            Utils.toast.success(this.$t("AccessRight")+" "+this.$t("DeletedSuccessfully"));
          });
        }
      });
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved() {
      this.gridInstance.refresh();
    },
  },
};
</script>